import { RoutePaths } from '@interfaces/routePaths'
import { Activity } from '@views/Record/Activity'
import { Base } from '@views/Record/Base'
import { Calls } from '@views/Record/Calls'
import { Files } from '@views/Record/Files'
import { Home } from '@views/Record/Home'
import { LinkedRecords } from '@views/Record/LinkedRecords'
import { Notes } from '@views/Record/Notes'
import { Tasks } from '@views/Record/Tasks'
import { BaseLayout } from '../BaseLayout'

export const RECORD_PATHS = [
  {
    path: `${RoutePaths.RECORD}/:recordId`,
    element: <BaseLayout />,
    children: [
      {
        path: RoutePaths.RECORD_HOME,
        element: (
          <Base>
            <Home />
          </Base>
        ),
      },
      {
        path: RoutePaths.RECORD_LINKED_RECORDS,
        element: (
          <Base>
            <LinkedRecords />
          </Base>
        ),
      },
      {
        path: RoutePaths.RECORD_TASKS,
        element: (
          <Base>
            <Tasks />
          </Base>
        ),
      },
      {
        path: RoutePaths.RECORD_ACTIVITY,
        element: (
          <Base>
            <Activity />
          </Base>
        ),
      },
      {
        path: RoutePaths.RECORD_CALLS,
        element: (
          <Base>
            <Calls />
          </Base>
        ),
      },
      {
        path: RoutePaths.RECORD_NOTES,
        element: (
          <Base>
            <Notes />
          </Base>
        ),
      },
      {
        path: RoutePaths.RECORD_FILES,
        element: (
          <Base>
            <Files />
          </Base>
        ),
      },
    ],
  },
]
